import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { whatsappNumber, siteContent } from '../data/mock';
import { MessageCircle, Sparkles } from 'lucide-react';

const Hero = () => {
  const { t, language } = useLanguage();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(siteContent[language].whatsappMessages.general);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-stone-50 to-rose-50/30"
    >
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-rose-100/40 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-stone-100/50 rounded-full blur-3xl" />
        <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-rose-50/60 rounded-full blur-2xl" />
      </div>

      {/* Subtle Pattern */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}
      />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-6 animate-fade-in">
            <img 
              src="https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/lvf4tsch_a-removebg-preview.png"
              alt="AB Nail Lounge"
              className="h-32 sm:h-40 md:h-48 w-auto mx-auto object-contain"
            />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm mb-6 animate-fade-in">
            <Sparkles className="w-4 h-4 text-rose-400" />
            <span className="text-sm text-stone-600 tracking-wide">Moncton, NB</span>
          </div>

          {/* Subtitle */}
          <p className="text-xl sm:text-2xl md:text-3xl text-rose-400 font-light tracking-widest mb-6 animate-slide-up-delay">
            {t.hero.subtitle}
          </p>

          {/* Description */}
          <p className="text-lg text-stone-500 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-delay">
            {t.hero.description}
          </p>

          {/* CTA Button */}
          <Button
            onClick={handleWhatsAppClick}
            size="lg"
            className="bg-stone-800 hover:bg-stone-700 text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group animate-fade-in-delay-2"
          >
            <MessageCircle className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
            {t.hero.cta}
          </Button>

          {/* Decorative Line */}
          <div className="mt-16 flex justify-center">
            <div className="w-px h-24 bg-gradient-to-b from-rose-300 to-transparent" />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-stone-300 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-stone-400 rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
